"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactList = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
class ContactList extends eventemitter3_1.default {
    contactsById = new Map();
    // TODO move this to SortedContactList
    contactIds = [];
    localNodeId;
    maxSize;
    constructor(localNodeId, maxSize) {
        super();
        this.localNodeId = localNodeId;
        this.maxSize = maxSize;
    }
    getContact(id) {
        return this.contactsById.get(id);
    }
    getSize() {
        return this.contactIds.length;
    }
    clear() {
        this.contactsById.clear();
        this.contactIds = [];
    }
    stop() {
        this.removeAllListeners();
        this.clear();
    }
}
exports.ContactList = ContactList;
//# sourceMappingURL=ContactList.js.map